
/* eslint-disable */
import SelectBox, { SelectBoxOptions } from "@/cloudfun/components/SelectBox.vue";
import CloudFun, { defineComponent, ref, reactive, PropType, Condition, Operator } from "@cloudfun/core";
import { watch } from "vue";
import { VxeTableProps } from "vxe-table";

interface Speaker {
  Name?: string;
  SpeakerId?: string;
  Speaker?: { Id: string, Name: string, Photo: any };
  Type: number;
  Ordinal: number;
  AgendaId: number;
}

export default defineComponent({
  name: "DocumentSpeakerTable",
  components: {
    SelectBox
  },
  props: {
    data: {
      type: Array as PropType<Speaker[]>,
      default: () => []
    },
    aid: Number,
    readonly: Boolean,
  },
  setup(props, { emit }) {
    const model = CloudFun.current?.model;
    const grid = ref<any>();
    const gridOptions = {
      props: {
        sortConfig: {
          defaultSort: { field: 'Ordinal', order: 'asc' }
        }
      } as VxeTableProps,
      insert() {
        const { row } = grid.value.insertAt({}, 0);
        grid.value.setActiveRow(row)
      }
    }

    const table = reactive({
      data: [] as Speaker[],
      isLoading: false,
      isEditing: false,
      formData: { Ordinal: 0 } as Speaker,
      selectedRow: null as Speaker | null,
      // insert() {
      //   table.formData = { OutSource: false, Fee: 0, PayStatus: 0, Ordinal: 0 };
      //   table.selectedRow = null;
      //   table.isEditing = true;
      // },
      update(row: Speaker) {
        table.formData = { ...row };
        table.selectedRow = row;
        table.isEditing = true;
      },
      delete(row: Speaker) {
        grid.value.remove(row);
      },
      async save() {
        if (table.formData.SpeakerId) {
          const temp = await model?.dispatch("speaker/find", table.formData.SpeakerId)
          table.formData.Speaker = { Id: temp.Id, Name: temp.Name, Photo: null };
          //table.formData.AgendaId = props.aid!;
        }

        await grid.value.insert(table.formData);
        grid.value.sort({ field: "Ordinal", order: 'asc' });

        //emit('refresh');
      },
      rules: {
        SpeakerId: [{ required: true }],
        Type: [{ required: true }],
        Ordinal: [{ required: true }],
      }
    })

    watch(() => props.data, async(value) => {
      console.log(value)
      const SpeakerIds = value.filter(e => e.SpeakerId).map(e => e.SpeakerId);
      const Speakers: Speaker['Speaker'][] = await model?.dispatch("speaker/query", { condition: new Condition("Id", Operator.In, SpeakerIds) });
      table.data = value.map(e => {
        if (e.SpeakerId) {
          const speaker = Speakers.find(a => a && a.Id === e.SpeakerId)
          if(speaker) e.Speaker = { Id: speaker!.Id, Name: speaker!.Name, Photo: null };
        } else {
        }
        return e;
      }).sort((a, b) => a.Ordinal - b.Ordinal);
    }, { immediate: true });

    const speakerForm = ref<any>();

    const userSelectorOptions: SelectBoxOptions = {
      rowId: "Id",
      transfer: true,
      placeholder: "選擇",
      textField: "Name",
      valueField: "Id",
      columns: [
        {
          field: "Name",
          title: "姓名",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          width: 200
        },
        {
          field: "Company",
          title: "公司名稱",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          width: 200
        },
        {
          field: "Department",
          title: "部門名稱",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          width: 200
        },
        {
          field: "Position",
          title: "職稱",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          width: 200
        }
      ],
      showHeader: true,
      promises: {
        find: value => model!.dispatch("speaker/find", value), // eslint-disable-line
        query: params => model!.dispatch("speaker/query", params) // eslint-disable-line
      }
    };
    return {
      table,
      grid,
      gridOptions,
      speakerForm,
      userSelectorOptions
    }
  },
  methods: {
    getData() {
      return this.grid.getTableData().fullData;
    }
  }
})
